<template>
  <div class="d-flex align-items-center">
    <div class="dropdown active">
      <PopoverRoot v-model:open="isMenuOpen">
        <PopoverTrigger
          class="dropdown-toggle drop_down"
          id="dropdownMenuButton1"
        />
        <PopoverContent
          as="ul"
          class="account_menu"
          side="bottom"
          align="start"
          :side-offset="10"
          :collision-padding="8"
          @click="isMenuOpen = false"
        >
        <li>
          <a class="dropdown-item" :href="TELEGRAM_SUPPORT" target="_blank">{{
            $t('header.account.support')
          }}</a>
        </li>
        <li>
          <div class="dropdown-item" @click="logout()">
            {{ $t('header.account.logout') }}
          </div>
        </li>
        </PopoverContent>
      </PopoverRoot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { PopoverRoot, PopoverTrigger, PopoverContent } from 'reka-ui'
import { TELEGRAM_SUPPORT, TELEGRAM_URL } from '@/helpers/variables'
import isMobile from '@/helpers/base/isMobile'

export default {
  data() {
    return {
      TELEGRAM_SUPPORT,
      TELEGRAM_URL,
      isMenuOpen: false,
      tooltip: {
        isOpen: false,
        info: {},
      },
    }
  },
  components: { PopoverRoot, PopoverTrigger, PopoverContent },
  computed: {
    ...mapGetters('userInfo', ['isLoggedIn']),
  },
  methods: {
    isMobile,
    closeTooltip(id) {
      this.tooltip.isOpen = false
    },
    ...mapMutations('userInfo', ['logout']),
  },
}
</script>
<style scoped>
.dropdown-toggle,
.dropdown-toggle:focus {
  border: none;
  outline: none;
  box-shadow: none;
  background: none;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
}

.dropdown.active button {
  font-weight: 900;
  font-size: 14px;
  background: linear-gradient(
    90deg,
    #ff70a3 0%,
    #fe6c74 18.65%,
    #b260ed 31.98%,
    #a162fa 8.65%,
    #70a8f7 99.99%,
    #70a7f7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.drop_down {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  max-width: 185px;
  white-space: pre-wrap;
  text-align: start;
  color: var(--text-secondary3);
  padding: 0 2px 0 0;
}

/* .dropdown.active {
  background: linear-gradient(
    90deg,
    #ff70a3 0%,
    #fe6c74 18.65%,
    #b260ed 31.98%,
    #a162fa 8.65%,
    #70a8f7 99.99%,
    #70a7f7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
} */

.drop_down::after {
  margin-left: 20px;
  width: 38px;
  height: 38px;
  border: none;
}

/* .drop_down::after {
  content: url('/InactiveSub.svg');
}

.dropdown.active .drop_down::after {
  content: url('/ActiveSub.svg');
} */

.drop_down::after {
  content: url('/ActiveSub.svg');
}

/* :v-deep(.drop_down),
:v-deep(.drop_down:focus),
:v-deep(.dropdown-toggle),
:v-deep(.dropdown-toggle:focus) {
  border: none;
  outline: none;
  box-shadow: none;
}

:v-deep(.dropdown-toggle) {
  display: flex;
  align-items: center;
}

:v-deep(.dropdown-menu) {
  border: 1px solid var(--border-color);
  box-sizing: border-box;
  padding: 12px 0;
  width: 229px;
  top: 10px;
}

:v-deep(.dropdown-item) {
  padding: 5px 12px;
  font-size: 14px;
}

:v-deep(.dropdown-item:hover) {
  background: var(--bg-hover);
  border-radius: 7px;
}

:v-deep(.dropdown-header) {
  padding: 0 12px;
}

:v-deep(.drop_down .dropdown-header > .title) {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--text-secondary3);
}

:v-deep(.drop_down.active .dropdown-header > .title) {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  display: inline-block;
  background: linear-gradient(
    90deg,
    #ff70a3 0%,
    #fe6c74 28.65%,
    #b260ed 61.98%,
    #a162fa 78.65%,
    #70a8f7 99.99%,
    #70a7f7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

:v-deep(.drop_down .dropdown-header > .description) {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-secondary3);
  margin-bottom: 7px;
}

:v-deep(.drop_down button) {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  max-width: 185px;
  white-space: pre-wrap;
  text-align: start;
  color: var(--text-secondary3);
  padding: 0 2px 0 0;
}

:v-deep(.drop_down.active button) {
  background: linear-gradient(
    90deg,
    #ff70a3 0%,
    #fe6c74 28.65%,
    #b260ed 61.98%,
    #a162fa 78.65%,
    #70a8f7 99.99%,
    #70a7f7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

:v-deep(.drop_down button::after) {
  border: none;
  content: url('/InactiveSub.svg');
  margin-left: 20px;
  width: 38px;
  height: 38px;
}

:v-deep(.drop_down.active button::after) {
  content: url('/ActiveSub.svg');
} */
</style>

<!-- меню рендерится в обёртке поппера Reka — стили глобальные -->
<style>
ul.account_menu {
  list-style: none;
  margin: 0;
  background: var(--bg-surface);
  border: 1px solid var(--border-color);
  box-sizing: border-box;
  padding: 12px 0;
  width: 229px;
  border-radius: 7px;
  font-size: 1rem;
  z-index: 1000;
}

ul.account_menu .dropdown-item {
  padding: 5px 12px;
  font-size: 14px;
  cursor: pointer;
}

ul.account_menu .dropdown-item:hover {
  background: var(--bg-hover);
  border-radius: 7px;
  text-decoration: none;
}

ul.account_menu .dropdown-item:active {
  color: var(--text-primary);
}

ul.account_menu .dropdown-header {
  padding: 0 12px;
  border-bottom: 1px solid var(--border-color);
}

ul.account_menu .title {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--text-secondary3);
}

ul.account_menu .description {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-secondary3);
  margin-bottom: 7px;
}
</style>
